import { render, staticRenderFns } from "./RoleSetAcls.vue?vue&type=template&id=5f0376d8&"
import script from "./RoleSetAcls.vue?vue&type=script&lang=js&"
export * from "./RoleSetAcls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports